import { render, staticRenderFns } from "./SalesGroupDetailsView.vue?vue&type=template&id=7523c314"
import script from "./SalesGroupDetailsView.vue?vue&type=script&lang=js"
export * from "./SalesGroupDetailsView.vue?vue&type=script&lang=js"
import style0 from "./SalesGroupDetailsView.vue?vue&type=style&index=0&id=7523c314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports